const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_RoleList":
      return { ...state, List: payload };
    case "SAVE_RoleDetail":
      return { ...state, Detail: payload };
    case "SAVE_RolePermissions":
      return { ...state, Permissions: payload };
    case "SAVE_RolePermissionsByUser":
      return { ...state, PermissionsUser: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
